import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/hamzah023" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href="https://www.linkedin.com/in/hamzahimrann/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
      </div>
      <p>by <a href="https://www.linkedin.com/in/hamzahimrann/https://www.linkedin.com/in/hamzahimrann/" target="_blank" rel="noreferrer">Hamzah </a> with 💜</p>
    </footer>
  );
}

export default Footer;